import BaseComponent from "../../../baseComponent.js";
import Chart from "./chart.jsx";
import Legends from "../timeseries-chart/legend/legends.jsx";


export default class LineStaticWidget extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // line static domain widget.jsx
    var componentModel;
    for (var componentId in this.props.components) {
      componentModel = this.props.components[componentId];
      break;
    }
    var chart;
    if (this.props.model.legends.length > 0) {
      // ideally the component controller should be created based off of the component model not legends
      // this is a single component widget, therefore only need to create one component controller
      chart = <Chart widgetId={this.props.model.id}
                     legends={this.props.model.legends}
                     componentModel={componentModel}
                     chartType={"line"}/>
    }
    return (
      <div>
        {chart}
        <Legends widgetId={this.props.model.id} metaData={this.props.model.metaData} legends={this.props.model.legends} widgetWidth={'470px'}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/line-static-chart/lineStaticWidget.jsx